import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area top-selling-products" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ms-2 ps-1" }
const _hoisted_8 = { class: "fw-medium fs-14" }
const _hoisted_9 = { class: "fs-12 text-body" }
const _hoisted_10 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_11 = { class: "fs-12 fw-medium" }
const _hoisted_12 = { "aria-label": "Page navigation example" }
const _hoisted_13 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Top Selling Products</h3><select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Today</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Product"),
                _createElementVNode("th", { scope: "col" }, "Price"),
                _createElementVNode("th", { scope: "col" }, "Order"),
                _createElementVNode("th", { scope: "col" }, "Stock"),
                _createElementVNode("th", { scope: "col" }, "Amount")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.product.image,
                          class: "wh-40 rounded-3",
                          alt: "product-1"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h6", _hoisted_8, _toDisplayString(item.product.name), 1),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.product.date), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, "$" + _toDisplayString(item.price), 1),
                  _createElementVNode("td", null, _toDisplayString(item.order), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.computeClass(item.stock))
                  }, _toDisplayString(item.stock), 3),
                  _createElementVNode("td", null, "$" + _toDisplayString(item.amount), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, " Showing " + _toDisplayString(_ctx.startItem + 1) + " to " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.items.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))])
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                  }, _toDisplayString(page), 9, _hoisted_14)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link icon",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))])
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}